<template>
  <div class="px-sm-4">
    <b-card body-class="p-md-1 p-0">
      <b-card-header class="align-items-start flex-sm-row flex-column-reverse">
        <b-card-title class="mt-sm-0 mt-2">
          <h4 class="mb-1">
            {{ $route.name == "account-withdraw" ? "Withdraw" : "Checkout" }}
          </h4>
        </b-card-title>

        <b-link
          :to="{
            name:
              $route.name == 'account-withdraw'
                ? 'wallet-withdraw'
                : 'financial-checkouts',
          }"
        >
          <span
            >back to the
            {{ $route.name == "account-withdraw" ? "Withdraw" : "Checkout" }}
            list</span
          >
          <feather-icon icon="ChevronRightIcon"
        /></b-link>
      </b-card-header>
      <b-card-body>
        <validation-observer ref="createForm">
          <b-form class="form mt-2" @submit.prevent="createForm">
            <div class="py-1">
              <h4 class="font-weight-normal">
                Total balance {{ parseFloat(currentBalance) }} $
              </h4>
            </div>
            <b-row>
              <b-col class="d-flex" lg="4">
                <b-form-group label-for="amount" class="w-100" label="Amount">
                  <validation-provider
                    #default="{ errors }"
                    name="Amount"
                    :rules="`required|min-value:0|max-value:${
                      parseFloat(currentBalance) < parseFloat(amount)
                        ? parseFloat(currentBalance)
                        : parseFloat(amount)
                    }`"
                  >
                    <b-form-input
                      id="amount"
                      v-model="amount"
                      name="amount"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <hr />
              </b-col>
              <template v-if="newAccountMode">
                <b-col
                  class="d-flex justify-content-end py-2"
                  cols="12"
                  v-if="accounts.length"
                >
                  <b-link @click="newAccountMode = false">
                    <span>back to the account list</span>
                    <feather-icon icon="ChevronRightIcon"
                  /></b-link>
                </b-col>
                <b-col class="d-flex" lg="4">
                  <b-form-group
                    label-for="currency-name"
                    class="w-100"
                    label="Currency name"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="currency name"
                      rules="required"
                    >
                      <b-form-input
                        id="currency-name"
                        v-model="currencyName"
                        name="currency-name"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col class="d-flex" lg="4">
                  <b-form-group
                    label-for="account-name"
                    class="w-100"
                    label="Account name"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="account name"
                      rules="required"
                    >
                      <b-form-input
                        id="account-name"
                        v-model="accountName"
                        name="account-name"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <hr />
                </b-col>
                <b-col lg="7">
                  <b-form-group
                    label-for="type"
                    class="w-100"
                    label="Choose a payment method"
                  >
                    <b-row>
                      <b-col class="d-flex" cols="12">
                        <div
                          @click="type = creditCard.value"
                          :class="`shadow-lg rounded ${
                            type == creditCard.value
                              ? 'border-warning'
                              : 'border'
                          } cursor-pointer d-flex align-items-center justify-content-center w-100 my-1 p-2`"
                          style="height: 80px"
                        >
                          <h3>
                            {{ creditCard.title }}
                          </h3>
                        </div>
                      </b-col>
                      <b-col class="d-flex" cols="12">
                        <div
                          @click="type = crypto.value"
                          :class="`shadow-lg rounded ${
                            type == crypto.value ? 'border-warning' : 'border'
                          } cursor-pointer d-flex align-items-center justify-content-center w-100 my-1 p-2`"
                          style="height: 80px"
                        >
                          <h3>
                            {{ crypto.title }}
                          </h3>
                        </div>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col lg="5" class="px-0">
                  <b-col
                    class="d-flex"
                    cols="12"
                    v-if="type.includes('master')"
                  >
                    <b-form-group
                      label-for="card-number"
                      class="w-100"
                      label="Card number"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="card number"
                        rules="required|max:19|min:13"
                      >
                        <b-form-input
                          id="card-number"
                          v-model="cardNumber"
                          name="card-number"
                          class="mt-lg-1"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    class="d-flex"
                    cols="12"
                    v-if="type.includes('crypto')"
                  >
                    <b-form-group
                      label-for="wallet-address"
                      class="w-100"
                      label="Wallet address"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Wallet address"
                        rules="required|max:64"
                      >
                        <b-form-input
                          id="wallet-address"
                          v-model="walletAddress"
                          name="wallet-address"
                          class="mt-lg-1"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col class="d-flex" cols="12" v-if="type.includes('ibn')">
                    <b-form-group label-for="ibn" class="w-100" label="IBN">
                      <validation-provider
                        #default="{ errors }"
                        name="IBN"
                        rules="required"
                      >
                        <b-form-input
                          id="ibn"
                          v-model="ibn"
                          name="ibn"
                          class="mt-lg-1"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col class="d-flex" cols="12">
                    <b-form-group
                      label-for="description"
                      class="w-100"
                      label="Description"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="description"
                      >
                        <b-form-textarea
                          id="description"
                          v-model="description"
                          name="description"
                          rows="4"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-col>
              </template>
              <template v-else>
                <b-col class="d-flex" lg="4" md="6">
                  <div
                    class="shadow-lg rounded border cursor-pointer d-flex align-items-center justify-content-center w-100 my-1 p-2 text-primary"
                    @click="newAccountMode = true"
                  >
                    <feather-icon icon="PlusIcon" />
                    Add new bank account
                  </div>
                </b-col>
                <template v-if="accountsLoading">
                  <b-col lg="4" md="6" v-for="i in 2" :key="i">
                    <div
                      class="shadow-lg rounded border cursor-pointer d-flex flex-column w-100 my-1 p-2"
                    >
                      <b-skeleton height="20px" width="120px" />
                      <b-skeleton height="20px" width="120px" />
                      <b-skeleton height="20px" width="120px" class="mb-0" />
                    </div>
                  </b-col>
                </template>
                <template v-else>
                  <b-col
                    lg="4"
                    md="6"
                    v-for="(account, index) in accounts"
                    :key="index"
                  >
                    <div
                      @click="selectedAccount = account"
                      :class="`shadow-lg rounded ${
                        selectedAccount.account_name == account.account_name
                          ? 'border-warning'
                          : 'border'
                      } cursor-pointer d-flex flex-column w-100 my-1 p-2`"
                    >
                      <div class="d-flex justify-content-between flex-wrap">
                        <span style="white-space: nowrap">Account name: </span>
                        <span
                          class="col-7 px-0 text-truncate"
                          style="white-space: nowrap"
                        >
                          {{ account.account_name || "-" }}
                        </span>
                      </div>
                      <div
                        class="d-flex justify-content-between flex-wrap mt-50"
                      >
                        <span style="white-space: nowrap">Currency name: </span>
                        <span
                          class="col-7 px-0 text-truncate"
                          style="white-space: nowrap"
                        >
                          {{ account.currency_name || "-" }}
                        </span>
                      </div>
                      <div
                        class="d-flex justify-content-between flex-wrap mt-50"
                      >
                        <span
                          v-if="
                            account.wallet_address ||
                            account.ibn ||
                            account.card_number
                          "
                          style="white-space: nowrap"
                          >{{
                            account.wallet_address
                              ? "Wallet address:"
                              : account.ibn
                              ? "IBN:"
                              : "Card number:"
                          }}</span
                        >
                        <span
                          class="col-7 px-0 text-truncate"
                          style="white-space: nowrap"
                        >
                          {{
                            account.wallet_address
                              ? account.wallet_address
                              : account.ibn
                              ? account.ibn
                              : account.card_number || "-"
                          }}
                        </span>
                      </div>
                    </div>
                  </b-col>
                </template>
              </template>
            </b-row>
            <div class="d-flex align-items-center flex-wrap">
              <b-button class="mt-sm-0 mt-50 mr-50 gradient-btn" type="submit">
                submit
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <loader :loading="loading" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BLink,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BFormTextarea,
  BMedia,
  BButtonGroup,
  BSkeleton,
  BImg,
} from "bootstrap-vue";
import { required, credit } from "@validations";
import Loader from "@/@core/components/loader/Loader.vue";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BLink,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    Loader,
    BFormTextarea,
    BMedia,
    BButtonGroup,
    BSkeleton,
    BImg,
  },
  data() {
    return {
      amount: "",
      currencyName: "",
      accountName: "",
      ibn: "",
      walletAddress: "",
      cardNumber: "",
      description: "",
      type: "master1",
      crypto: {
        value: "crypto1",
        title: "Crypto",
      },
      creditCard: {
        value: "master1",
        title: "Credit Card",
      },
      selectedAccount: {},
      accounts: [],
      accountsLoading: false,
      loading: false,
      newAccountMode: false,
      currentBalance: "",
      // validation rules
      credit,
      required,
    };
  },
  created() {
    this.getAccounts();
    this.getBalance();
  },

  methods: {
    async getBalance() {
      try {
        const { data } = await this.$http.get("panel/profile/user/wallet");
        this.currentBalance = data.current_balance;
      } catch (error) {}
    },
    async getAccounts() {
      this.accountsLoading = true;
      try {
        const { data } = await this.$http.get("/panel/checkout/accounts");
        data.data.length == 0 ? (this.newAccountMode = true) : "";
        this.accounts = data.data;
        this.selectedAccount = data.data[0];
      } catch (err) {}
      this.accountsLoading = false;
    },
    createForm() {
      this.$refs.createForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            let newObject = {
              currency_name: this.newAccountMode
                ? this.currencyName
                : this.selectedAccount.currency_name,
              account_name: this.newAccountMode
                ? this.accountName
                : this.selectedAccount.account_name,
              description: this.newAccountMode
                ? this.description
                : this.selectedAccount.description,
            };

            if (this.newAccountMode) {
              this.cardNumber && this.type.includes("master")
                ? (newObject.card_number = this.cardNumber)
                : this.walletAddress && this.type.includes("crypto")
                ? (newObject.wallet_address = this.walletAddress)
                : (newObject.ibn = this.ibn);
            } else {
              this.selectedAccount.wallet_address
                ? (newObject.wallet_address =
                    this.selectedAccount.wallet_address)
                : this.selectedAccount.card_number
                ? (newObject.card_number = this.selectedAccount.card_number)
                : (newObject.ibn = this.selectedAccount.ibn);
            }

            const { data } = await this.$http.post("/panel/checkout/request", {
              amount: this.amount,
              bank_account: { ...newObject },
            });
          } catch (err) {}
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style></style>
